import { createRef, useRef } from 'react'
import { instanceOf, string, number, shape } from 'prop-types'
import Masonry from 'react-masonry-component'
import { CSSTransition } from 'react-transition-group'

import GridCardBanner from './grid-card-banner.js'
import GridFeedPost from './grid-feed-post.js'
import GridDisplayPost from './grid-display-post.js'
import Settings from '../../../../../models/settings.js'

const TRANSITION = {
  classNames: 'fade-scale-transition',
  appear: true,
  timeout: 500,
  in: true,
}

function GrdFeedContent({
  settings,
  columns,
  postWidth,
  maxPosts,
  observer,
  feed,
  containerElement,
  containerWidth,
  feedKey,
}) {
  const { sameSizePosts } = settings

  const containerColumns = []
  const container = []

  const blockColumns = Math.ceil(columns / 2)
  let containerSize = 0
  const posts = feed.posts.filter((p) => p.hasMedia || p.isYoutubePost)

  const tiles = posts.slice(0, maxPosts)
  const tilesCount = tiles.length

  const nodeRefs = useRef(Array.from({ length: tilesCount }).map(() => createRef()))

  for (let i = 0; i < tilesCount; i += 1) {
    let type
    const post = tiles[i]
    const rowNumber = Math.ceil(containerColumns.length / blockColumns)
    const lastColumnInOddNumberColumnLayout =
      columns % 2 === 1 &&
      (containerColumns.length + 1) % blockColumns === 0 &&
      containerColumns.length !== 0
    let largePost =
      (i + 1) % 3 === 0 &&
      rowNumber % 2 === 0 &&
      containerSize < 3 &&
      !lastColumnInOddNumberColumnLayout

    if (columns === 1 || columns === 2 || sameSizePosts) {
      largePost = false
    }

    containerSize += largePost ? 4 : 1
    const width = largePost ? postWidth.width * 2 : postWidth.width
    // calc width to get correct image size
    const postImageWidth = largePost ? postWidth.imageWidth * 2 : postWidth.imageWidth

    const tileRef = nodeRefs.current[i]
    if (settings.showCardBanner && i === 3) {
      type = (
        <CSSTransition nodeRef={tileRef} {...TRANSITION}>
          <GridCardBanner innerRef={tileRef} settings={settings} />
        </CSSTransition>
      )
    } else {
      type = (
        <GridFeedPost
          additionalStyles={{}}
          feedKey={feedKey}
          locale={settings.locale}
          observer={observer}
          post={post}
          settings={settings}
          transitionOptions={TRANSITION}
          width={postImageWidth}
        />
      )
    }

    const finalPost = (
      <div key={`post-${i}`} className="bzfy-o-layout__item" style={{ width }}>
        {type}
      </div>
    )
    container.push(finalPost)
  }

  const wrapperStyle = {
    width: containerWidth && containerWidth - (containerWidth % columns),
    marginLeft: 'auto',
    marginRight: 'auto',
  }
  return (
    <div style={wrapperStyle}>
      <div className="bzfy-o-layout">
        {/* Adding disableImagesLoaded property here to counteract known issue: https://github.com/desandro/imagesloaded/issues/175 */}
        <Masonry disableImagesLoaded>{container}</Masonry>
      </div>
      {settings.isAutoTheme ? (
        <GridDisplayPost
          containerElement={containerElement}
          feed={feed}
          feedKey={feedKey}
          settings={settings}
        />
      ) : null}
    </div>
  )
}

GrdFeedContent.propTypes = {
  columns: number.isRequired,
  containerElement: instanceOf(HTMLElement).isRequired,
  containerWidth: number.isRequired,
  feed: shape().isRequired,
  feedKey: string.isRequired,
  maxPosts: number.isRequired,
  observer: instanceOf(IntersectionObserver).isRequired,
  postWidth: shape().isRequired,
  settings: instanceOf(Settings).isRequired,
}

export default GrdFeedContent
